import Box from '@mui/joy/Box'
import Tooltip from '@mui/joy/Tooltip'
import Typography from '@mui/joy/Typography'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import type { ReactNode } from 'react'

/** A label followed by an info icon; hovering or focusing the icon explains what the number means. */
export default function InfoHint({ children, hint }: { children: ReactNode; hint: string }) {
    return (
        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
            {children}
            <Tooltip
                arrow
                placement="top"
                variant="outlined"
                enterTouchDelay={0}
                title={
                    <Typography level="body-sm" sx={{ maxWidth: 340, whiteSpace: 'normal', textTransform: 'none', letterSpacing: 'normal' }}>
                        {hint}
                    </Typography>
                }
            >
                <InfoOutlinedIcon tabIndex={0} aria-label="What this means" sx={{ fontSize: 15, color: 'text.tertiary', cursor: 'help' }} />
            </Tooltip>
        </Box>
    )
}
